export default __webpack_public_path__ + "static/media/photo--lg--wheel-12.b6e07507.jpg";